import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppLocalizationService } from '../../../../services/AppLocalizationService';
import { DestroyBase } from '../../../../components/common/ng-destroy-base';
import { DateUtil } from '../../../../components/common/date-util/date-util';
import { EventBusService } from '../../../../services/event-bus.service';

/**
 * Date field that displays values ***IN RD LOCALE***
 */
@Component({
  selector: 'pollux-report-designer-date-field',
  templateUrl: './pollux-report-designer-date-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PolluxReportDesignerDateFieldComponent extends DestroyBase implements OnInit {

  /**
   * Allow null values?
   */
  @Input() isNullable: boolean;

  /**
   * Read-only
   */
  @Input() ngReadonly: boolean;

  /**
   * ID for HTML
   */
  @Input() ngId: string;

  /**
   * Internal model
   */
  public internalModel: Date;

  /**
   * Gets the value model
   */
  get ngModel(): string {
    if (this.internalModel) {
      return DateUtil.dateToUtcString(this.internalModel);
    }
    return null;
  }

  /**
   * Sets the value model
   */
  @Input() set ngModel(value: string) {
    this.internalModel = DateUtil.getDate(value);
    this.ref.markForCheck();
  }

  /**
   * ng-model change listener
   */
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter<any>();

  /**
   * ng-model change listener
   */
  @Output() ngChange: EventEmitter<any> = new EventEmitter<any>();

  /**
   * The date format
   */
  public dateFormat: string;

  /**
   * Constructor
   * @param appLocalization
   * @param eventBus
   * @param ref
   */
  constructor(private appLocalization: AppLocalizationService, private eventBus: EventBusService, private ref: ChangeDetectorRef) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.eventBus.subscribeEvent('localeChanged', () => {
      this.applyLocale();
    });

    this.applyLocale();
  }

  /**
   * Allies the current RD locale and gets the date format
   */
  private applyLocale(): void {
    const dictionaryConfig = this.appLocalization.getReportDesignerDictionaryConfig();
    this.dateFormat = dictionaryConfig.dateFormat;
    if (!this.dateFormat) {
      this.dateFormat = 'dd/MM/yyyy';
    }
    this.ref.markForCheck();
  }

  /**
   * Model change handler
   */
  public modelChanged() {
    const externalValue = DateUtil.dateToUtcString(this.internalModel);
    this.ngChange.next(externalValue);
    this.ngModelChange.next(externalValue);
    this.ref.markForCheck();
  }
}
